import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  format,
  lightFormat,
  addDays,
} from 'date-fns'
import {
  MOBILE_GUIDE_CARD_RENDITIONS,
  GUIDE_CARD_RENDITIONS,
} from '../../constants'
import isLive from '../../utils/isLive'
import handleApiError from '../../utils/handleApiError'
import { ScheduleCard } from '..'
import PlayerApi from '../../utils/playerApi'
import getImageRenditions from '../../utils/getImageRenditions'
import styles from './styles'

const OnNowOnNext = ({
  channel,
  error,
  programmeGuid,
  initialSchedule,
  sportsExclusive,
}) => {
  const [assets, setAssets] = useState(initialSchedule)
  const playerApi = PlayerApi()

  const extractOnNowOnNextResultsData = e => ({
    title: e?.title,
    channel: e?.channel,
    summary: e?.summary,
    link: e?.programme && e?.programme?._permalink && `/summary/${e?.programme?.guid}`,
    restartEnabled: e?.restartEnabled,
    episode: e?.episode,
    startTime: e?.startTime,
    endTime: e?.endTime,
    id: `${e?.channel}_${e?.startTime}`,
    image: getImageRenditions(
      e?.programme?.images?.[7]?._filepath,
      MOBILE_GUIDE_CARD_RENDITIONS,
    ),
    modalImage: getImageRenditions(
      e?.programme?.images?.[0]?._filepath,
      GUIDE_CARD_RENDITIONS
    ),
  })

  useEffect(() => {
    const updateNowNext = async () => {
      try {
        const date = format(new Date(), 'yyyy-MM-dd')
        const tomorrow = addDays(new Date(date), 1)
        const dateList = lightFormat(tomorrow, 'yyyy-MM-dd').split('-')

        const { results, reason: scheduleError } = await playerApi({
          path: `/schedule/`,
          query: {
            startTime: `>=${date} 05:15:00`,
            endTime: `<=${dateList[0]}-${dateList[1]}-${dateList[2]} 06:01:59`,
            orderBy: 'startTime',
            limit: 200,
            channel,
          },
        })

        if (scheduleError) return { error: handleApiError({ apiError: scheduleError }) }

        const filteredResults = results
          .map(extractOnNowOnNextResultsData)

        let onNowOnNextAssets = {}

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < filteredResults.length; i++) {
          if (isLive(results[i].startTime, results[i].endTime)) {
            onNowOnNextAssets = filteredResults.slice(i, i + 3)
          }
        }

        setAssets(onNowOnNextAssets)
      } catch (err) {
        setAssets(null)
      }
      return null
    }
    updateNowNext()
  }, [programmeGuid, channel])

  return (
    !error && assets && (
      <section className="OnNowOnNext">
        <ScheduleCard
          isOnNow
          position={1}
          sportsExclusive={sportsExclusive}
          cardTitle={'Live'}
          {...assets[0]}
        />
        <ScheduleCard
          isOnNext
          position={2}
          sportsExclusive={sportsExclusive}
          cardTitle={'Next'}
          {...assets[1]}
        />
        <ScheduleCard
          isOnLater
          position={3}
          sportsExclusive={sportsExclusive}
          cardTitle={'Later'}
          {...assets[2]}
        />
        <style jsx>{styles}</style>
      </section>
    )
  )
}

const mapStateToProps = ({ playerApiCache }, { channel }) => ({
  programmeGuid: playerApiCache[`/streams/${channel}`]?.results?.now?.programme?.guid,
})

OnNowOnNext.propTypes = {
  channel: PropTypes.string.isRequired,
  error: PropTypes.bool,
  programmeGuid: PropTypes.string,
  sportsExclusive: PropTypes.bool,
  initialSchedule: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    channel: PropTypes.string,
    summary: PropTypes.string,
    link: PropTypes.string,
    restartEnabled: PropTypes.bool,
    episode: PropTypes.object,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.object,
    modalImage: PropTypes.object,
  })),
}

OnNowOnNext.defaultProps = {
  error: false,
  programmeGuid: null,
  initialSchedule: null,
  sportsExclusive: false,
}

export default connect(mapStateToProps)(OnNowOnNext)
